import { V2_RESULT_STATUS } from './types';

const cloneStimulus = (stimulus) => {
  if (!stimulus) return null;
  return Array.isArray(stimulus) ? [...stimulus] : { ...stimulus };
};

const createTiming = (startedAt, endedAt = null) => ({
  startedAt,
  endedAt,
  durationMs: endedAt === null ? null : Math.max(0, endedAt - startedAt),
});

export const createV2Repetition = ({
  repetitionIndex,
  startedAt,
}) => ({
  repetitionIndex,
  timing: createTiming(startedAt),
  completion: {
    status: V2_RESULT_STATUS.ACTIVE,
    reason: null,
  },
  result: null,
});

export const createV2Production = ({
  productionId,
  monitor,
  stimulus,
  productionIndex,
  startedAt,
}) => ({
  productionId,
  monitor: { ...monitor },
  context: {
    productionIndex,
    stimulus: cloneStimulus(stimulus),
  },
  timing: createTiming(startedAt),
  repetitions: [],
  completion: {
    status: V2_RESULT_STATUS.ACTIVE,
    reason: null,
  },
  result: null,
});

export const createV2RepetitionResult = ({
  repetition,
  endedAt,
  reason,
  result,
  status = V2_RESULT_STATUS.COMPLETED,
}) => ({
  ...repetition,
  timing: createTiming(repetition.timing.startedAt, endedAt),
  completion: { status, reason },
  result,
});

export const createV2ProductionResult = ({
  production,
  repetitions,
  endedAt,
  reason,
  result,
  status = V2_RESULT_STATUS.COMPLETED,
}) => ({
  ...production,
  timing: createTiming(production.timing.startedAt, endedAt),
  repetitions: [...repetitions],
  completion: { status, reason },
  result,
});